import TopLayoutBlog from 'docs/src/modules/components/TopLayoutBlog';
import { docs } from './matheus-wichman-joining.md?muiMarkdown';

export default function Page() {
  return <TopLayoutBlog docs={docs} />;
}
